import { useStyles } from './ValidationRow.styles';

interface ValidationRowProps {
  helperText: string;
  limitsVisible: boolean;
  valueLength: number;
  limit: number;
  withError?: boolean;
  helperTextStyle?: { [key: string]: string };
}

export const ValidationRow: React.FC<ValidationRowProps> = ({
  helperText,
  limitsVisible,
  valueLength,
  limit,
  withError,
  helperTextStyle,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.helperRow}>
      <div style={helperTextStyle}>{helperText}</div>
      {limitsVisible && (
        <div className={`${classes.fieldLimits} ${withError ? classes.error : ''}`}>
          {valueLength}/{limit}
        </div>
      )}
    </div>
  );
};
